<template>
  <transition name="slide-card">
    <div class="startup" v-if="startupOpen" v-bind:class="{'startup-open': startupOpen}">
      <div class="container">
        <div>
          <h2>Bienvenue Dans Time to Play</h2>
          <p>
            Il semblerait que ce soit la première attraction pendant laquelle vous jouez à time to play.<br/>
            Choisissez ci-dessous votre personnage et votre couleur pour jouer !
          </p>
          
          <div class="list-container">
            <ul>
              <li v-for="plop in listColors" v-on:click="setColor(plop)">
                <div class="profile medium" :class="[plop, {'selected': plop == selectedColor}]" v-on:click="openProfile()">
                  
                </div>
              </li>
            </ul>
          </div>

          <div class="list-container">
            <ul>
              <li v-for="plop in listCharacters" v-on:click="setCharacter(plop)">
                <div class="profile medium" :class="[selectedColor, {'selected': plop == selectedCharacter}]" v-on:click="openProfile()">
                  <img :src="'/static/img/characters/'+plop+'.png'" />
                </div>
              </li>
            </ul>
          </div>

          <button class="primary reverse big" v-on:click="closeStartup()">Commencer</button>

          

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'profile',

  data: function () {
    return {
      listCharacters: ['mickey', 'minnie', 'peterpan', 'tinkerbell', 'wendy', 'donald', 'goofy'],
      listColors: ['color0', 'color2', 'color3', 'color4', 'color5', 'color6'],
      selectedColor: 'color0',
      selectedCharacter: 'mickey',
      startupOpen: true
    }
  },

  methods: {
    openProfile: function () {
      this.profileOpened = !this.profileOpened
    },

    setColor: function (c) {
      this.selectedColor = c
      this.$store.commit('saveColor', this.selectedColor)
    },

    setCharacter: function (c) {
      this.selectedCharacter = c
      this.$store.commit('saveCharacter', this.selectedCharacter)
    },

    closeStartup: function () {
      // alert('coucou')
      this.startupOpen = false
      this.$store.commit('onboarded')
      // this.$store.commit('gainStars', {ride: 'peterpan', stars: 300})
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/startup.vue